import { ContentService } from '@blk/cwp-ng-framework';

export class DcrUpdateUtil {

	public static getAdvisoryFeeText(contentService: ContentService, advisoryFee?: number): string {
		advisoryFee = advisoryFee || +contentService.get('ADVISORY_FEE', '3');

		const contentMapping = new Map();
		contentMapping.set('$ADVISORY_FEE$', advisoryFee);

		const dcrText = contentService.get('ADVISORY_FEE_TEXT', ' of $ADVISORY_FEE$% advisory fee');
		return contentService.getSubstitutedValuesString(dcrText, contentMapping);
	}

	public static getAdvisoryFeeTextForPerformanceLegend(contentService: ContentService, dcrKey: string, defaultValue: string, advisoryFee?: number): string {
		advisoryFee = advisoryFee || +contentService.get('ADVISORY_FEE', '3');

		const contentMapping = new Map();
		contentMapping.set('$ADVISORY_FEE$', advisoryFee);

		const dcrText = contentService.get(dcrKey, defaultValue);
		return contentService.getSubstitutedValuesString(dcrText, contentMapping);
	}

	public static getAdvisoryFeeTextForPdf(contentService: ContentService, advisoryFee?: number): string {
		return this.getAdvisoryFeeText(contentService, advisoryFee);
	}

}
